import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class MicrosoftContactAdapterHelper  {
    _originalTypeClassName = "ekylikeio.BO.MicrosoftContactAdapterHelper";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
MicrosoftContactAdapterHelper.translate = translateService;
}
this.MicrosoftContactAdapterHelperKey = null;
this._key = this.MicrosoftContactAdapterHelperKey = 0; 
}

static translate: TranslateService;
_key: any;
private _MicrosoftContactAdapterHelperKey:any;
get MicrosoftContactAdapterHelperKey(): any {
    return this._MicrosoftContactAdapterHelperKey;
  }
set MicrosoftContactAdapterHelperKey(value: any) {
    this._MicrosoftContactAdapterHelperKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.MicrosoftContactAdapterHelperKey == null || $this.MicrosoftContactAdapterHelperKey == 0;
            }


}